import styled from '@emotion/styled';
import { themeGet } from '@styled-system/theme-get';

const StyledAddon = styled.div`
  position: relative;
  margin: ${themeGet('scale.scaleDown01')} 0;
  padding: ${themeGet('scale.scaleUp01')} ${themeGet('scale.scaleUp03')};
  font-size: ${themeGet('scale.scaleUp02')};
  background-color: ${themeGet('color.colorWhite')};
  box-shadow: ${themeGet('boxShadow.boxShadowLarge')};
  border: ${themeGet('border.borderSmall')} solid transparent;
  border-radius: ${themeGet('border.borderRadius')};

  @media (max-width: ${themeGet('breakpoint.breakpointMobile')}) {
    text-align: center;
  }

  h3 {
    @media (max-width: ${themeGet('breakpoint.breakpointMobile')}) {
      font-size: ${themeGet('scale.scaleUp03')};
    }
  }

  .tag {
    position: relative;
    top: -10px;

    @media (max-width: ${themeGet('breakpoint.breakpointMobile')}) {
      position: absolute;
      right: 10px;
    }
  }

  .addon-content {
    display: flex;
    margin-top: ${themeGet('scale.scaleDown04')};

    button {
      min-width: 130px;
    }

    @media (max-width: ${themeGet('breakpoint.breakpointMobile')}) {
      flex-direction: column;
      margin-top: ${themeGet('scale.scaleBase')};
    }
  }

  .addon-price {
    @media (max-width: ${themeGet('breakpoint.breakpointMobile')}) {
      margin-top: ${themeGet('scale.scaleBase')};
      margin-bottom: ${themeGet('scale.scaleBase')};
    }
  }

  .icon-wrapper {
    display: none;
    position: absolute;
    top: -8px;
    right: -8px;
    width: 18px;
    height: 18px;
    margin-right: 0;
    border-radius: 50%;
    background-color: ${themeGet('color.colorBlue')};

    div {
      margin: -4px auto 0;
    }
  }

  &.is-selected {
    border-color: ${themeGet('color.colorBlue')};

    .icon-wrapper {
      display: block;
    }
  }

  &.is-disabled {
    .addon-price {
      color: ${themeGet('color.colorGrayBlue60')};
    }
  }
`;

export default StyledAddon;
